import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isTransferred: false, // Default value
};

const transferSlice = createSlice({
  name: "transfer",
  initialState,
  reducers: {
    setTransferredTrue: (state) => {
      state.isTransferred = true;
    },
    setTransferredFalse: (state) => {
      state.isTransferred = false;
    },
    toggleTransferred: (state) => {
      state.isTransferred = !state.isTransferred;
    },
  },
});

export const { setTransferredTrue, setTransferredFalse, toggleTransferred } =
  transferSlice.actions;
export default transferSlice.reducer;
